import http from "@/http-common";

const BASE = "receipt/v1/invoice";

class ManagingStudentInvoiceService {
  searchInvoices(data) {
    return http.post(`${BASE}/search`, data);
  }

  getMaxTurn(params) {
    return http.get(`${BASE}/max-turn`, { params });
  }

  updateHideReceipt(data) {
    return http.put(`${BASE}/hide-receipt`, data);
  }

  deleteFee(data) {
    return http.post(`${BASE}/delete-fee`, data);
  }

  renameFee(data) {
    return http.put(`${BASE}/rename-fee`, data);
  }

  batchAddRevenue(data) {
    return http.post(`${BASE}/batch-add-revenue`, data);
  }

  getUnpaidInvoices(idStudent, targetType) {
    return http.get(`${BASE}/unpaid`, { params: { idStudent, targetType } });
  }

  getStudentInvoiceHistory(idStudent, targetType) {
    return http.get(`${BASE}/student-history`, { params: { idStudent, targetType } });
  }

  getStudentInvoiceSummary(idStudent) {
    return http.get(`${BASE}/student-summary`, { params: { idStudent } });
  }

  filterStudentInvoiceSummary(data) {
    return http.post(`${BASE}/student-summary/filter`, data);
  }

  exportStudentInvoices(data) {
    return http.post(`${BASE}/student-summary/export`, data);
  }

  adjustPayment(data) {
    return http.put(`${BASE}/adjust-payment`, data);
  }

  getAdditionalInfo(idx) {
    return http.get(`${BASE}/additional-info`, { params: { idx } });
  }

  updateAdditionalInfo(idx, data) {
    return http.put(`${BASE}/additional-info`, data, { params: { idx } });
  }

  getInvoiceDetailItem(invoiceIdx, detailIdx) {
    return http.get(`${BASE}/detail-item`, { params: { invoiceIdx, detailIdx } });
  }

  updateInvoiceDetailItem(data) {
    return http.put(`${BASE}/detail-item`, data);
  }

  /**
   * Lấy chi tiết phiếu thu để hiển thị dialog thanh toán
   * @param {String} idx - UUID của phiếu thu
   */
  getInvoiceDetail(idx) {
    return http.get(`${BASE}/detail`, { params: { idx } });
  }

  /**
   * Thanh toán phiếu thu
   * @param {Object} data - Thông tin thanh toán
   */
  payInvoice(data) {
    return http.post(`${BASE}/pay`, data);
  }

  /**
   * Thanh toán hàng loạt phiếu thu
   * @param {Object} data - Thông tin thanh toán hàng loạt
   */
  batchPayInvoices(data) {
    return http.post(`${BASE}/batch-pay`, data);
  }


  /**
   * Lấy lịch sử thanh toán của phiếu thu
   * @param {String} idx - UUID của phiếu thu
   */
  getPaymentHistory(idx) {
    return http.get(`${BASE}/payment-history`, { params: { idx } });
  }


  /**
   * Tạo ghi chú hàng loạt cho các phiếu thu
   * @param {Object} data - { note: String, idxList: Array<String> }
   */
  batchUpdateNote(data) {
    return http.put(`${BASE}/batch-note`, data);
  }

  /**
   * Lấy chi tiết nhiều phiếu thu phục vụ in hàng loạt
   * @param {Object} data - { idxList: Array<String> }
   */
  getBatchDetail(data) {
    return http.post(`${BASE}/batch-detail`, data);
  }

  /**
   * Huỷ phiếu thu hàng loạt
   * @param {Object} data - { idxList: Array<String> }
   */
  cancelInvoices(data) {
    return http.put(`${BASE}/cancel`, data);
  }

  /**
   * Xoá phiếu thu hàng loạt
   * @param {Object} data - { idxList: Array<String> }
   */
  deleteInvoices(data) {
    return http.put(`${BASE}/delete`, data);
  }

  /**
   * Xoá phiếu thu lớp/nhóm cũ theo ID
   * @param {Object} data - { idx: String, currentTargetId: Number, currentTargetType: String }
   */
  deleteInvoiceByIds(data) {
    return http.put(`${BASE}/delete-by-ids`, data);
  }

  /**
   * Khôi phục phiếu thu hàng loạt
   * @param {Object} data - { idxList: Array<String> }
   */
  restoreInvoices(data) {
    return http.put(`${BASE}/restore`, data);
  }

  /**
   * Áp dụng tài khoản thanh toán trực tuyến cho phiếu thu hàng loạt
   * @param {Object} data - { applicableBankID: Number, idx: Array<String> }
   */
  registerBankForInvoice(data) {
    return http.put(`${BASE}/apply-bank`, data);
  }

  /**
   * Gửi SMS thông báo học phí
   * @param {Object} data - { idxList: Array<String> }
   */
  sendSmsForInvoices(data) {
    return http.post(`${BASE}/send-sms`, data);
  }

  /**
   * Gửi thông báo học phí qua App Onekids
   * @param {FormData} data - Dữ liệu form chứa thông tin thông báo, file đính kèm và idxList
   */
  sendAppForInvoices(data) {
    return http.post(`${BASE}/send-app`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  /**
   * Lấy danh sách lịch sử thay đổi (phân trang)
   * @param {Object} data - { idx: String, page: Number, size: Number }
   */
  getAuditHistory(data) {
    return http.get(`${BASE}/audit-history`, { params: data });
  }

  /**
   * Lấy chi tiết 1 bản ghi audit (snapshot phiếu thu)
   * @param {String} auditId - MongoDB _id của bản ghi audit
   */
  getAuditDetail(auditId) {
    return http.get(`${BASE}/audit-detail`, { params: { auditId } });
  }

  /**
   * Đồng bộ dữ liệu điểm danh
   */
  syncAttendance(data) {
    return http.post(`${BASE}/sync-attendance`, data);
  }

  /**
   * Bước 1 Excel Import (API 1): Lấy danh mục khoản thu áp dụng
   * POST /receipt/v1/invoice/excel-import/step1/fee-catalog
   * @param {Object} data { targetType, targetId, month, year, turn }
   */
  getExcelImportStep1FeeCatalog(data) {
    return http.post(`${BASE}/excel-import/step1/fee-catalog`, data);
  }

  /**
   * Bước 1 Excel Import (API 2): Lấy dữ liệu để xuất file Excel mẫu
   * POST /receipt/v1/invoice/excel-import/step1/template-data
   * @param {Object} data { targetType, targetId, month, year, turn, listIdKids, includeAttendance, attendanceMonth, includePreviousDebt }
   */
  getExcelImportStep1TemplateData(data) {
    return http.post(`${BASE}/excel-import/step1/template-data`, data);
  }

  /**
   * Bước 2 Excel Import: Kiểm tra phiếu thu được đánh dấu thanh toán online (chặn ghi đè)
   * POST /receipt/v1/invoice/excel-import/check-online-payment
   * @param {Object} data { listInvoiceCodes, targetType, targetId, month, year, turn }
   */
  checkExcelImportOnlinePayment(data) {
    return http.post(`${BASE}/excel-import/check-online-payment`, data);
  }

  /**
   * Bước 3 Excel Import: Lưu danh sách phiếu thu import từ Excel vào CSDL
   * POST /receipt/v1/invoice/excel-import/create-invoices
   * @param {Object} data { targetType, targetId, turn, invoices: [...] }
   */
  createInvoicesFromExcel(data) {
    return http.post(`${BASE}/excel-import/create-invoices`, data);
  }

  /**
   * Tạo phiếu thu cho một học sinh từ phiếu cùng lớp
   * POST /receipt/v1/invoice/copy-for-student
   * @param {Object} data { studentCode, month, year, turn }
   */
  copyForStudent(data) {
    return http.post(`${BASE}/copy-for-student`, data);
  }

  /**
   * Tạo phiếu thu cho một hoặc nhiều học sinh từ phiếu cùng lớp (1–100 học sinh/lần)
   * POST /receipt/v1/invoice/copy-for-students
   * @param {Object} data { studentCodes, month, year, turn }
   */
  copyForStudents(data) {
    return http.post(`${BASE}/copy-for-students`, data);
  }
}

export default new ManagingStudentInvoiceService();
